import * as config from '@/config-APP_TARGET';

export const game = {
	// score
	score: {
		vowels: new Map([['A', 1], ['E', 1], ['I', 1], ['O', 1], ['U', 4]]),
		consonants: new Map([
			['B', 4],
			['C', 1],
			['D', 4],
			['F', 4],
			['G', 4],
			['L', 2],
			['M', 2],
			['N', 2],
			['P', 3],
			['R', 1],
			['S', 1],
			['T', 1],
			['V', 4],
			['Q', 10],
			['H', 8],
			['Z', 8],
			['J', 12],
			['K', 12],
			['W', 12],
			['X', 12],
			['Y', 12]
		]),
		won: 1
	},
};

export const colors = {
	// Lettere
	board: 0xdcddde,
	boardBlink: 0xf7941e,
	boardOver: 0xf7941e,
	letter: 0x0072b1,
	letterOver: 0xdcddde,
	letterDisabled: 0x807e7f,
	green: 0xa5bd3a, // rgb(165,189,58)
	yellow: 0xeccc36,
	blue: 0x45578d,
	red: 0xc13208,
	orange: 0xf7941e, // rgb(247,148,30)
	gray: 0x245d8b,
	leapStyleFillColor: {
		win: '#82a110',
		lost: '#e12044'
	}
};

export const styles = {
	//letter
	colorLetterStyle: {
		fontSize: 55,
		fontFamily: 'Titillium Web',
		fontStyle: 'bold',
		fill: '#FFFFFF',
		align: 'center'
	},
	colorLetterStyleMin: {
		fontSize: 45,
		fontFamily: 'Titillium Web',
		fontStyle: 'bold',
		fill: '#FFFFFF',
		align: 'center'
	},
	// Stile per titoli molto lunghi (> 40 caratteri)
	colorLetterStyleXMin: {
		fontSize: 38,
		fontFamily: 'Titillium Web',
		fontStyle: 'bold',
		fill: '#FFFFFF',
		align: 'center',
		letterSpacing: -2
	},

	// Logo
	backgroundLogo: {
		x: 0,
		y: 0,
		width: config.width,
		height: 80,
		style: {
			thickness: 1,
			color: 0x0072b1,
			alpha: 1
		}
	},
	// Background ditloide
	backgroundDitloide: {
		x: 0,
		y: 0,
		width: config.width,
		height: 80,
		style: {
			thickness: 1,
			color: 0x000000,
			alpha: 0.5
		}
	},

	// style dell'animazione del contatore
	leapStyle: {
		fontSize: 40,
		fontFamily: 'Luckiest Guy',
		align: 'center'
	},

	// style dei contatori
	counterStyle: {
		fontSize: 45,
		fontFamily: 'Luckiest Guy',
		fill: '#FFFFFF',
		align: 'center'
	},
	titleStyle: {
		fontSize: 70,
		fontFamily: 'Luckiest Guy',
		fill: '#eccc36',
		align: 'center'
	},
	textStyle: {
		fontSize: 40,
		fontFamily: 'Arial',
		fill: '#FFFFFF',
		align: 'center'
	},
	// style del text game over
	gameOver: {
		counterStyle: {
			fontSize: 50,
			fontFamily: 'Luckiest Guy',
			fill: '#e12044',
			align: 'center'
		},
		greetingStyle: {
			fontSize: 50,
			fontFamily: 'Luckiest Guy',
			fill: '#000000',
			align: 'center'
		},
		greetings: {
			fair: 'Risolto!',
			ok: 'Ok!',
			good: 'Ottimo!',
			excellent: 'Eccellente!',
			super: 'Superlativo!'
		}
	},

	superpowerTitleStyle: {
		fontSize: 45,
		fontFamily: 'Luckiest Guy',
		fill: '#FFFFFF',
		align: 'center'
	},

	superpowerStyle: {
		fontSize: 45,
		fontFamily: 'Luckiest Guy',
		color: '#a5bd3a',
		align: 'center'
	},

	superpowerShadowStyle: {
		offsetX: 2,
		offsetY: 2,
		color: 'rgb(94,94,94)'
			//fill: 0
	}
};

export const labels = {
	win: 'Hai vinto!\nPunti: ',
	lost: 'Hai perso!\nPunti: ',
	superpower: 'AIUTI',
	playAgain: 'Gioca',
	quit: 'Menù',
	howtoPlayTitle: 'Gioca con libri, film e canzoni'
};

export const box = {
	// Caselle
	width: 64,
	height: 67,
	rows: 10,
	cols: 8,
	repeat: 80,
	scale: 0.95
};

export const margin = {
	//lettere
	lettersMarginTop: 10,

	// Ditloide
	ditloideMarginTop: 40,

	buttonPlayMarginTop: 70,
	greetingMarginTop: 20,
	paddingButtons: 100,
	superpowerMarginTop: 3
};

export const various = {
	letterRepeat: 20,
	helpButton: {
		alpha: 0.7
	}
};

/**
 *  Custom global parameters of the game
 */
export const wordToShow = [
	"'",
	'.',
	':',
	';',
	'?',
	'!',
	'di',
	'a',
	'da',
	'in',
	'con',
	'su',
	'per',
	'tra',
	'fra',
	'e',
	'il',
	'lo',
	'la',
	"l'",
	'i',
	'gli',
	'le',
	'del',
	'dello',
	'della',
	"dell'",
	'dei',
	'degli',
	'delle',
	'al',
	'allo',
	'alla',
	"all'",
	'ai',
	'agli',
	'alle',
	'dal',
	'dallo',
	'dalla',
	"dall'",
	'dai',
	'dagli',
	'dalle',
	'nel',
	'nello',
	'nella',
	"nell'",
	'nei',
	'negli',
	'nelle',
	'col',
	'collo',
	'colla',
	'coi',
	'cogli',
	'colle',
	'sul',
	'sullo',
	'sulla',
	"sull'",
	'sui',
	'sugli',
	'sulle',
	'un',
	'uno',
	'una'
];
